import * as React from 'react';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';

import { DropdownButton } from 'components/ContainerActions';
import { Archive } from './Archive';
import { AddCustomerId } from './AddCustomerId';

export const TableActionsDropdown: React.FC = () => {
  const [isOpen, setIsOpen] = React.useState(false);

  return (
    <DropdownButton
      label="Table actions"
      className="shadow-sm"
      endIcon={<ArrowDropDownIcon />}
      isOpen={isOpen}
      onRequestOpen={setIsOpen}
      placement="bottom-end"
    >
      <div className="flex flex-col space-y-2">
        <AddCustomerId onClick={() => setIsOpen(false)} />
        <Archive onClick={() => setIsOpen(false)} />
      </div>
    </DropdownButton>
  );
};
